import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

interface NewsItem {
  id: number;
  title: string;
  date: string;
  category: string;
  image: string;
  excerpt: string;
  content: string;
}

export default function NewsPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState<NewsItem | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const newsData: NewsItem[] = [
    {
      id: 1,
      title: 'إنجاز مشروع غرفة مقاومة للحريق بمساحة 900 متر مربع',
      date: '15 ديسمبر 2024',
      category: 'مشاريع',
      image: 'https://public.readdy.ai/ai/img_res/3f9066c8f9e8ab0e9fe87b3387a9a144.jpg',
      excerpt: 'نجحت شركة الهمة الذهبية في إنجاز مشروع إنشاء غرفة مقاومة للحريق بمساحة 900 متر مربع لصالح مصرف الراجحي بالرياض',
      content: 'أعلنت شركة الهمة الذهبية عن إنجاز مشروع إنشاء غرفة مقاومة للحريق بمساحة 900 متر مربع في مستودعات مصرف الراجحي بالرياض مخرج 16. يشمل المشروع جميع الأعمال الميكانيكية والكهربائية والمدنية بأعلى معايير الجودة والسلامة. تم تنفيذ المشروع وفقاً لأحدث المواصفات العالمية في مجال السلامة والحماية من الحرائق.'
    },
    {
      id: 2,
      title: 'توسع الشركة في تقديم خدمات أنظمة السلامة بالمنطقة الشرقية',
      date: '10 ديسمبر 2024',
      category: 'أخبار الشركة',
      image: 'https://readdy.ai/api/search-image?query=Fire%20safety%20systems%20installation%20across%20multiple%20commercial%20buildings%2C%20professional%20fire%20protection%20equipment%20with%20water%20tanks%20and%20pumps%2C%20modern%20safety%20infrastructure%20in%20Eastern%20Province%20Saudi%20Arabia%2C%20corporate%20construction%20photography%20with%20professional%20quality&width=800&height=600&seq=news-safety-expansion-001&orientation=landscape',
      excerpt: 'تواصل شركة الهمة الذهبية توسعها في المنطقة الشرقية من خلال تنفيذ مشاريع أنظمة السلامة في عدة فروع',
      content: 'في إطار خطة التوسع الاستراتيجية، نجحت شركة الهمة الذهبية في تنفيذ مشاريع أنظمة السلامة والحريق في عدة فروع بالمنطقة الشرقية شملت الدمام والخبر ورأس تنورة. تضمنت المشاريع توريد وتركيب وفحص وتشغيل خزانات ومضخات الحريق شاملاً جميع التمديدات لصناديق الحريق، بالإضافة إلى فحص وصيانة جميع أنظمة الحريق القائمة.'
    },
    {
      id: 3,
      title: 'الهمة الذهبية تحصل على شهادة الجودة ISO 9001:2015',
      date: '5 ديسمبر 2024',
      category: 'إنجازات',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20team%20celebrating%20ISO%20certification%20achievement%2C%20corporate%20executives%20holding%20quality%20management%20certificate%2C%20modern%20office%20setting%20with%20professional%20photography%20and%20elegant%20composition&width=800&height=600&seq=news-iso-certificate-001&orientation=landscape',
      excerpt: 'حصلت شركة الهمة الذهبية على شهادة نظام إدارة الجودة ISO 9001:2015 تأكيداً على التزامها بأعلى معايير الجودة',
      content: 'في خطوة تعكس التزام الشركة بالتميز والجودة، حصلت شركة الهمة الذهبية على شهادة نظام إدارة الجودة ISO 9001:2015. تأتي هذه الشهادة تتويجاً لجهود الشركة المستمرة في تطوير أنظمة العمل وتحسين جودة الخدمات المقدمة للعملاء. وتؤكد الشركة أن هذا الإنجاز يعزز من مكانتها كإحدى الشركات الرائدة في مجال المقاولات والإنشاءات في المملكة.'
    },
    {
      id: 4,
      title: 'إطلاق برنامج تدريبي متخصص للكوادر الوطنية',
      date: '1 ديسمبر 2024',
      category: 'أخبار الشركة',
      image: 'https://readdy.ai/api/search-image?query=Professional%20construction%20training%20program%20for%20Saudi%20workers%2C%20young%20engineers%20and%20technicians%20learning%20modern%20construction%20techniques%2C%20corporate%20training%20facility%20with%20safety%20equipment%20and%20educational%20materials%2C%20professional%20photography%20with%20clean%20background&width=800&height=600&seq=news-training-program-001&orientation=landscape',
      excerpt: 'أطلقت شركة الهمة الذهبية برنامجاً تدريبياً شاملاً لتأهيل الكوادر الوطنية في مجالات المقاولات والإنشاءات',
      content: 'انطلاقاً من مسؤوليتها الاجتماعية ودعماً لرؤية المملكة 2030، أطلقت شركة الهمة الذهبية برنامجاً تدريبياً متخصصاً يهدف إلى تأهيل الكوادر الوطنية في مختلف مجالات المقاولات والإنشاءات. يشمل البرنامج تدريباً عملياً ونظرياً في الأعمال الميكانيكية والكهربائية والمدنية وأنظمة السلامة، بإشراف نخبة من الخبراء والمتخصصين.'
    },
    {
      id: 5,
      title: 'إتمام مشروع ترميم شامل لفرع الكعكية بمكة المكرمة',
      date: '25 نوفمبر 2024',
      category: 'مشاريع',
      image: 'https://readdy.ai/api/search-image?query=Modern%20bathroom%20renovation%20project%20in%20commercial%20building%2C%20elegant%20restroom%20facilities%20with%20contemporary%20fixtures%20and%20finishes%2C%20professional%20renovation%20work%20with%20high-quality%20materials%2C%20corporate%20construction%20photography%20with%20clean%20professional%20style&width=800&height=600&seq=news-makkah-renovation-001&orientation=landscape',
      excerpt: 'أنجزت الشركة مشروع ترميم وصيانة شاملة لدورات المياه في فرع الكعكية بمكة المكرمة',
      content: 'أتمت شركة الهمة الذهبية بنجاح مشروع ترميم وصيانة شاملة لدورات المياه في فرع الكعكية بمكة المكرمة التابع لمصرف الراجحي. تضمن المشروع إعادة تأهيل كاملة للمرافق باستخدام أحدث المواد والتقنيات، مع مراعاة أعلى معايير الجودة والنظافة. وقد تم تنفيذ المشروع في وقت قياسي دون التأثير على سير العمل في الفرع.'
    },
    {
      id: 6,
      title: 'الهمة الذهبية تطلق مبادرة للاستدامة البيئية',
      date: '20 نوفمبر 2024',
      category: 'إنجازات',
      image: 'https://readdy.ai/api/search-image?query=Green%20sustainable%20construction%20practices%2C%20eco-friendly%20building%20materials%20and%20renewable%20energy%20systems%2C%20environmental%20sustainability%20in%20construction%20industry%2C%20corporate%20photography%20with%20natural%20elements%20and%20professional%20quality&width=800&height=600&seq=news-sustainability-initiative-001&orientation=landscape',
      excerpt: 'أطلقت الشركة مبادرة شاملة للاستدامة البيئية في جميع مشاريعها التزاماً بالمسؤولية البيئية',
      content: 'في خطوة رائدة نحو الاستدامة البيئية، أطلقت شركة الهمة الذهبية مبادرة شاملة تهدف إلى تطبيق أفضل الممارسات البيئية في جميع مشاريعها. تشمل المبادرة استخدام مواد صديقة للبيئة، تقليل النفايات، ترشيد استهلاك الطاقة والمياه، وتطبيق أنظمة إدارة بيئية متقدمة. وتأتي هذه المبادرة انسجاماً مع رؤية المملكة 2030 والتزام الشركة بالمسؤولية الاجتماعية والبيئية.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#202835] shadow-lg' : 'bg-[#202835]'}`}>
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-24">
            <Link className="flex items-center" to="/">
              <img 
                alt="شركة الهمة الذهبية" 
                className="h-16 w-auto" 
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
              />
            </Link>

            <nav className="hidden lg:flex items-center gap-8">
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/">
                الرئيسية
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/about">
                من نحن
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/services">
                الخدمات
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group" to="/projects">
                المشاريع
                <span className="absolute bottom-0 right-0 w-0 h-0.5 bg-[#d4af37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link className="relative text-white font-semibold transition-all duration-300 hover:text-[#d4af37] group text-[#d4af37]" to="/news">
                الأخبار
                <span className="absolute bottom-0 right-0 w-full h-0.5 bg-[#d4af37]"></span>
              </Link>
            </nav>

            <Link className="hidden lg:block px-8 py-3 bg-[#d4af37] text-white font-bold rounded-full hover:bg-[#c19b2e] transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer" to="/contact">
              تواصل معنا
            </Link>

            <button 
              className="lg:hidden text-white text-2xl w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#202835] border-t border-white/10">
            <nav className="container mx-auto px-6 py-4 flex flex-col gap-4">
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/">الرئيسية</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/about">من نحن</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/services">الخدمات</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/projects">المشاريع</Link>
              <Link className="text-white font-semibold text-[#d4af37] transition-colors" to="/news">الأخبار</Link>
              <Link className="text-white font-semibold hover:text-[#d4af37] transition-colors" to="/contact">تواصل معنا</Link>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section className="relative h-[400px] w-full overflow-hidden mt-24">
        <div className="absolute inset-0 w-full h-full">
          <img 
            alt="أخبار شركة الهمة الذهبية" 
            className="w-full h-full object-cover object-center" 
            src="https://readdy.ai/api/search-image?query=Modern%20construction%20company%20news%20and%20updates%20banner%2C%20professional%20corporate%20communication%20concept%20with%20newspaper%20and%20digital%20media%20elements%2C%20business%20journalism%20in%20construction%20industry%2C%20corporate%20photography%20with%20clean%20professional%20style&width=1920&height=800&seq=news-hero-banner-001&orientation=landscape"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#202835]/80 via-[#202835]/70 to-[#202835]/80"></div>
        </div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="container mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
              أخبار الشركة
            </h1>
            <div className="w-20 h-0.5 bg-[#d4af37] mx-auto mb-4"></div>
            <p className="text-xl text-white/90 max-w-2xl mx-auto">
              تابع آخر أخبار وإنجازات شركة الهمة الذهبية
            </p>
          </div>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {newsData.map((news) => (
              <div
                key={news.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer"
                onClick={() => setSelectedNews(news)}
              >
                <div className="relative w-full h-[250px] overflow-hidden">
                  <img
                    alt={news.title}
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                    src={news.image}
                  />
                  <div className="absolute top-4 right-4">
                    <span className="px-4 py-2 bg-[#d4af37] text-white text-sm font-semibold rounded-full">
                      {news.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 text-[#202835]/60 text-sm mb-3">
                    <i className="ri-calendar-line"></i>
                    <span>{news.date}</span>
                  </div>
                  <h3 className="text-xl font-bold text-[#202835] mb-3 line-clamp-2">
                    {news.title}
                  </h3>
                  <p className="text-[#202835]/70 leading-relaxed mb-4 line-clamp-3">
                    {news.excerpt}
                  </p>
                  <div className="flex items-center gap-2 text-[#d4af37] font-semibold group-hover:gap-3 transition-all duration-300">
                    <span>اقرأ المزيد</span>
                    <i className="ri-arrow-left-line"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* News Modal */}
      {selectedNews && (
        <div
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedNews(null)}
        >
          <div
            className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative w-full h-[400px]">
              <img
                alt={selectedNews.title}
                className="w-full h-full object-cover object-center"
                src={selectedNews.image}
              />
              <button
                onClick={() => setSelectedNews(null)}
                className="absolute top-4 left-4 w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-[#d4af37] hover:text-white transition-all duration-300 cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
              <div className="absolute bottom-4 right-4">
                <span className="px-4 py-2 bg-[#d4af37] text-white text-sm font-semibold rounded-full">
                  {selectedNews.category}
                </span>
              </div>
            </div>
            <div className="p-8">
              <div className="flex items-center gap-2 text-[#202835]/60 text-sm mb-4">
                <i className="ri-calendar-line"></i>
                <span>{selectedNews.date}</span>
              </div>
              <h2 className="text-3xl font-bold text-[#202835] mb-6">
                {selectedNews.title}
              </h2>
              <p className="text-lg text-[#202835]/80 leading-relaxed">
                {selectedNews.content}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="relative bg-[#202835] text-white overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            <div>
              <Link className="inline-block mb-6" to="/">
                <img 
                  alt="شركة الهمة الذهبية" 
                  className="h-16 w-auto" 
                  src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/c39a188db929712e2f2919bb54dee404.png"
                />
              </Link>
              <p className="text-white/80 leading-relaxed mb-6">
                شركة الهمة الذهبية، شريكك الموثوق في عالم المقاولات والإنشاءات.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">روابط سريعة</h3>
              <ul className="space-y-3">
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/about">من نحن</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/services">الخدمات</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/projects">المشاريع</Link></li>
                <li><Link className="text-white/80 hover:text-[#d4af37] transition-colors" to="/news">الأخبار</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">خدماتنا</h3>
              <ul className="space-y-3">
                <li className="text-white/80">الإنشاءات والبناء</li>
                <li className="text-white/80">الترميم والصيانة</li>
                <li className="text-white/80">الأعمال الكهربائية</li>
                <li className="text-white/80">أنظمة السلامة</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold text-[#d4af37] mb-6">تواصل معنا</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-phone-line text-[#d4af37] text-xl mt-1"></i>
                  <div>
                    <div dir="ltr">+966 50 016 5920</div>
                    <div dir="ltr">+966 50 125 5250</div>
                  </div>
                </li>
                <li className="flex items-start gap-3 text-white/80">
                  <i className="ri-mail-line text-[#d4af37] text-xl mt-1"></i>
                  <span>info@gmcc.com.sa</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 py-6">
            <p className="text-white/60 text-sm text-center">
              © 2024 شركة الهمة الذهبية. جميع الحقوق محفوظة.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
